import React from 'react';
import { Box, Spinner } from '@amzn/awsui-components-core';
import { useConnectionsScorecards } from './useConnectionsData';
import { LeaderScorecardGrid } from './LeaderScorecardGrid';

interface DetailRendererProps {
  data?: { leaderLogin?: string };
  context?: { startDate?: string; metricPeriod?: string };
}

export const LeaderDirectsDetailRenderer: React.FC<DetailRendererProps> = ({ data, context }) => {
  const leaderLogin = data?.leaderLogin || null;
  const startDate = context?.startDate || null;
  const metricPeriod = context?.metricPeriod || 'MONTHLY_TRAILING_THREE_MONTHS';
  const state = useConnectionsScorecards(metricPeriod, 'LEADER_ID:DIRECT_ORGS', '', 'ADJUSTED_POSITIVE_RESPONSE_RATE', leaderLogin, startDate);

  if (state.loading) {
    return (
      <Box textAlign="center" padding="m">
        <Spinner /> Loading directs...
      </Box>
    );
  }
  if (!state.data || state.data.length === 0) {
    return (
      <Box textAlign="center" padding="m" color="text-body-secondary">
        No direct-report data for this leader.
      </Box>
    );
  }
  return (
    <Box padding="s">
      <LeaderScorecardGrid scorecards={state.data} enableDrillDown startDate={startDate || undefined} compact />
    </Box>
  );
};
